import {Language} from "./types";

export enum CampaignType {
  Basic = 'basic',
  FreePayout = 'freePayout'
}

export enum CampaignState {
  New = 'new',
  Launched = 'launched',
  Ongoing = 'ongoing',
  Completed = 'completed',
  Aborted = 'aborted',
  Failed = 'failed'
}

export enum TransportType {
  Notification = 'notification',
  Sms = 'sms',
  Email = 'email'
}

////////////
// Audiences
////////////
type IndividualsAudienceRequestModel = {
  type: 'individuals'
  userIds: string[]
}

type ActiveEmployeesAudienceRequestModel = {
  type: 'activeEmployees',
  employerIds?: string[]
}

type ActiveUsersAudienceRequestModel = {
  type: 'activeUsers',
}

export type AudienceRequestModel = IndividualsAudienceRequestModel | ActiveEmployeesAudienceRequestModel | ActiveUsersAudienceRequestModel

type AudienceModelBase = {
  recipients: CampaignRecipient[]
}

type IndividualsAudienceModel = AudienceModelBase & {
  type: 'individuals'
}

type ActiveEmployeesAudienceModel = AudienceModelBase & {
  type: 'activeEmployees',
  employers?: EmployerAudienceMember[]
}

type ActiveUsersAudienceModel = AudienceModelBase & {
  type: 'activeUsers'
}

export type AudienceModel = IndividualsAudienceModel | ActiveEmployeesAudienceModel | ActiveUsersAudienceModel

///////////////////
// Campaigns models
///////////////////
type BaseCampaign = {
  id: string
  type: CampaignType
  name: string
  executionTime: string
  state: CampaignState
  transportType: TransportType
  audience?: AudienceModel
  messages: CampaignTranslation[]
  result?: CampaignResult
}

export type Campaign =
  | (BaseCampaign & {
  type: CampaignType.Basic
})
  | (BaseCampaign & {
  type: CampaignType.FreePayout
  numberOfFreePayouts: number
})

export interface CampaignResult {
  errorMessage?: string
  successfulRecipients: CampaignRecipient[]
  failedRecipients: CampaignRecipient[]
}

export interface CampaignTranslation {
  language: Language
  title: string
  summary: string
}

export interface EmployerAudienceMember
{
  id : string
  name : string
}

export interface CampaignRecipient {
  id: string
  givenName: string
  familyName: string
  identificationNumber: string
}

////////////////////////////////////
// Create or update campaigns models
////////////////////////////////////
type BaseCreateOrUpdateCampaignModel = {
  type: CampaignType
  name: string
  executionTime: string
  transportType: TransportType
}

type BasicCreateOrUpdateCampaignModel = BaseCreateOrUpdateCampaignModel & {
  type: CampaignType.Basic
}

type FreePayoutCreateOrUpdateCampaignModel = BaseCreateOrUpdateCampaignModel & {
  type: CampaignType.FreePayout,
  numberOfFreePayouts: number
}

export type CreateOrUpdateCampaignModel = BasicCreateOrUpdateCampaignModel | FreePayoutCreateOrUpdateCampaignModel
